module.exports = __webpack_public_path__ + "img/selected7-min.6a4395d4.png";